<template>
  <CalculatorPIPView
    :acceptable-counties-from="acceptableCountiesFrom"
    :acceptable-counties-to="acceptableCountiesTo"
    :country-from-default="COUNTRY_CODES.RUSSIA"
    :hide-promocode-option="hidePromocodeOption"
    :calc-import="calcImport"
    :acceptable-force-promocode="true"
    :result-page="resultPage"
    :personal-agreement-link="personalAgreementLink"
    :luggage-delivery="luggageDelivery"
    :hide-menu="hideMenu"
    @senderChangeCountry="onSenderChangeCountry"
  />
</template>

<script>
import CalculatorPIPView from './CalculatorPIPView.vue';
import { COUNTRY_CODES } from '../../helpers/constans';

export default {
  name: 'CalcPIPWithImportViewVue',
  components: { CalculatorPIPView },
  props: {
    resultPage: {
      type: Boolean,
      default: false,
    },
    luggageDelivery: {
      type: Boolean,
      default: false,
    },
    hideMenu: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    countrySelected: null,
    personalAgreementLink: '/castnym-klientam/info-klientam/dokumenty',
  }),
  computed: {
    calcImport() {
      return this.countrySelected !== COUNTRY_CODES.RUSSIA;
    },
    hidePromocodeOption() {
      return false;
    },
    acceptableCountiesTo() {
      if (this.countrySelected === COUNTRY_CODES.KYRGYZSTAN) {
        return [COUNTRY_CODES.RUSSIA, COUNTRY_CODES.BELARUS, COUNTRY_CODES.ARMENIA, COUNTRY_CODES.KAZAKHSTAN];
      }
      if (this.countrySelected === COUNTRY_CODES.KAZAKHSTAN) {
        return [COUNTRY_CODES.RUSSIA, COUNTRY_CODES.BELARUS, COUNTRY_CODES.KYRGYZSTAN, COUNTRY_CODES.ARMENIA];
      }
      if (this.countrySelected === COUNTRY_CODES.BELARUS) {
        return [COUNTRY_CODES.RUSSIA, COUNTRY_CODES.KAZAKHSTAN, COUNTRY_CODES.KYRGYZSTAN, COUNTRY_CODES.ARMENIA];
      }
      if (this.countrySelected === COUNTRY_CODES.ARMENIA) {
        return [COUNTRY_CODES.RUSSIA, COUNTRY_CODES.KAZAKHSTAN, COUNTRY_CODES.KYRGYZSTAN, COUNTRY_CODES.BELARUS];
      }
      return this.calcImport ? [COUNTRY_CODES.RUSSIA] : [];
    },
    acceptableCountiesFrom() {
      return [COUNTRY_CODES.RUSSIA, COUNTRY_CODES.KAZAKHSTAN, COUNTRY_CODES.KYRGYZSTAN, COUNTRY_CODES.BELARUS, COUNTRY_CODES.ARMENIA];
    },
  },
  created() {
    this.COUNTRY_CODES = COUNTRY_CODES;
  },
  methods: {
    onSenderChangeCountry(country) {
      this.countrySelected = country;
    },
  },
};
</script>
